import React from 'react'

import './header-horoscope.scss'
import MenuSigns from '../menu-signs/menu-signs'
import { useStaticQuery, graphql } from 'gatsby'

const HeaderHoroscope = props => {
    const resultQuery = useStaticQuery(
        graphql`
        query GET_HOROSCOPE_CONTENT{
            allContentfulNolHomeTercerNivel(filter: {titulo: {eq: "Horóscopo"}}) {
                nodes {
                    node_locale
                    titulo
                    slug
                    banner {
                        bannerSecciones {
                        file {
                            url
                        }
                        fixed {
                                    base64
                                }
                        description
                        }
                        tituloBanner
                    }
                    signosDeLosHoroscopos {
                        titulo
                        iconoDelSigno
                        slug
                    }
                }
            }
        }
        
    `
    )
    var infoHoroscope = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]
    const [pageLoad, setPageLoad] = React.useState(false);
    React.useEffect(() => {
        setPageLoad(true)
    }, [])
    // var news_info=props.dataProp
    return (
        <div className="f-header-horoscope">
            <div className="f-header-horoscope-banner">
                <img 
                    alt={infoHoroscope.banner.bannerSecciones[0].description} 
                    src={pageLoad ? infoHoroscope.banner.bannerSecciones[0].file.url : infoHoroscope.banner.bannerSecciones[0].fixed.base64} 

                />
            </div>
            <div className="f-header-horoscope-title">
                {props.sign ? <h2><span>{infoHoroscope.titulo}</span> {infoHoroscope.banner.tituloBanner}</h2> : <h1>{infoHoroscope.titulo}</h1>}
            </div>
            <MenuSigns signs={infoHoroscope.signosDeLosHoroscopos} activeSign={props.sign} setPageChange={props.setPageChange}/>
        </div>
    )
}

export default HeaderHoroscope;
